module.exports = __webpack_public_path__ + "img/SD.00324c4f.svg";